import React from 'react';
import LowerRise from '../../../img/header_bg_lowrise_tile.png';
import HigherRise from '../../../img/header_bg_highrise.png';
import BrandedLogo from '../../common/BrandedLogo';

const WSUPBgHeader = (props) => {
    return (
        <div
            style={{
                marginBottom: '20px',
                marginLeft: '-10px',
                marginRight: '-10px',
                marginTop: '-10px',
                backgroundPosition: 'bottom',
                backgroundColor: '#fff',
                backgroundRepeat: 'repeat-x',
                height: '175px',
            }}
        >
            <div
                style={{
                    height: '100%',
                    backgroundImage: `url(${LowerRise})`,
                    backgroundRepeat: 'repeat-x',
                    backgroundPosition: '-492px bottom',
                    // backgroundPosition: 'right bottom',
                    backgroundSize: 'auto 100%',
                }}
            >
                <div style={{ width: '100%' }}>
                    <div
                        style={{
                            width: `calc(100% - 100px)`,
                            float: 'left',
                            marginLeft: '50px',
                        }}
                    >
                        <div
                            style={{
                                minWidth: 150,
                                maxWidth: 260,
                            }}
                        >
                            <BrandedLogo />
                        </div>
                    </div>

                    <div
                        style={{
                            backgroundImage: `url(${HigherRise})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'right bottom',
                            backgroundSize: 'auto 100%',
                            height: '175px',
                            right: '0',
                            width: '100%',
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

WSUPBgHeader.propTypes = {};

export default WSUPBgHeader;
